import styled from 'styled-components';
import React from 'react';
import media from 'client/styles/media';

import PaddingContainer from './PaddingContainer';

const ConnectionsSection = styled.section`
  position: relative;
  padding: 230px 0 60px;
  width: 100%;
  background: url(https://static.introwise.com/images/elements/main/connection_mob.svg) center 80px no-repeat;
  &:before {
    content: '';
    display: block;
    position: absolute;
    left: 0;
    top: -5px;
    right: 0;
    height: 20px;
    background: url('https://static.introwise.com/images/elements/main/intersect_white.svg') top left repeat-x;
    z-index: 10;
  }
  h2 {
    ${({ theme }) => theme.typography.hero};
    font-size: 36px;
    letter-spacing: -0.02em;
    line-height: 110%;
    margin: 0 0 16px;
  }
  p {
    margin: 0 0 1em;
  }
  ${media.sm} {
    padding: 230px 0 80px;
  }
  ${media.md} {
    padding: 100px 0 170px;
    background: none;
    h2 {
      font-size: 56px;
      margin-bottom: 45px;
    }
  }
  ${media.lg} {
    ${PaddingContainer} {
      display: grid;
      grid-template-columns: repeat(12, 1fr);
    }

    h2 {
      grid-column: 2 / span 11;
    }
  }
`;

const ConnectionsText = styled.div`
  margin-bottom: 50px;
  ${media.lg} {
    grid-column: 2 / span 3;
  }
`;
const ConnectionsBlocks = styled.div`
  color: ${({ theme }) => theme.color.text};
  max-width: 500px;
  margin: 0 auto;
  position: relative;
  h3 {
    margin: 0 0 17px;
    font-size: 26px;
  }
  .plus {
    display: none;
    text-align: center;
  }

  ${media.sm} {
    display: flex;
    align-items: stretch;
    max-width: none;
    align-content: space-between;
    .plus {
      display: block;
      width: 10%;
      align-self: center;
    }
  }
  ${media.md} {
    &:before {
      content: '';
      display: block;
      width: 881px;
      height: 447px;
      background: url(https://static.introwise.com/images/elements/main/connection_desc.svg) center no-repeat;
      background-size: cover;
      position: absolute;
      z-index: -1;
      top: 50%;
      left: 50%;
      transform: translate(-48%, -45%);
    }
  }
  ${media.lg} {
    align-content: space-around;
    justify-content: center;
    grid-column: 5 / span 8;
    .plus {
      width: 6%;
    }
  }
`;

const ConnectionsBlock = styled.div`
  position: relative;
  min-height: 220px;
  max-width: 320px;
  padding: 25px 30px 30px 30px;
  z-index: 1;
  background-color: rgba(255, 255, 255, 0.84);
  background-repeat: no-repeat;
  box-shadow: 0px 0px 20px rgba(37, 38, 94, 0.1);
  border-radius: 16px;

  &.events {
    background-image: url('https://static.introwise.com/images/elements/main/art_1.svg');
    background-position: 95% 12px;
    margin-left: -30px;
    margin-right: auto;
  }
  &.communities {
    margin-top: -40px;
    background-image: url('https://static.introwise.com/images/elements/main/art_2.svg');
    background-position: 105% -16px;
    margin-right: -30px;
    margin-left: auto;
  }
  ${media.sm} {
    margin: auto;
    max-width: none;
    width: 45%;
    &.events,
    &.communities {
      margin: auto;
    }
  }
  ${media.md} {
    min-height: 240px;
    width: 40%;
    &.events,
    &.communities {
      background-image: none;
    }
  }
`;

const Connections = () => (
  <ConnectionsSection>
    <PaddingContainer>
      <h2>Where meaningful connections happen</h2>
      <ConnectionsText>
        <p>
          Introwise is&nbsp;a&nbsp;modern platform for interaction and engagement using interests-based group chats to
          create meaningful unintentional connections.
        </p>
        <p>We help event participants and community members meet people based on shared interests.</p>
      </ConnectionsText>

      <ConnectionsBlocks>
        <ConnectionsBlock className="events">
          <h3>Events</h3>
          <p>A place where people meet and make connections and where communities grow.</p>
        </ConnectionsBlock>
        <div className="plus">
          <svg width="53" height="49" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M34.1 10.78c-.45 2.23-1.15 6.5-2.22 10.68a639.56 639.56 0 0 1-6.63 24c-.4 1.33-2 2.3-3.04 3.45-.98-1.5-2.94-3.14-2.77-4.5.85-6.91 2.29-13.76 3.47-20.63 1-5.87 2.03-11.74 2.9-17.63.35-2.42-1.22-5.89 2.9-6.14 3.62-.22 5.38 2.1 5.39 5.7v5.07z"
              fill="#F78B86"
            />
            <path
              d="M29.82 21.84c6.35 0 12.7-.07 19.04.07 1.16.03 2.29.91 3.43 1.4-.83 1.26-1.39 3.2-2.53 3.64-2.42.92-5.14 1.4-7.75 1.46-8.69.21-17.39-.04-26.07.28-4.2.16-8.34 1.3-12.53 1.77-1.1.13-2.98-.26-3.26-.93-.39-.94.01-3.1.72-3.45 3.18-1.62 6.5-3.6 9.92-3.95 6.3-.62 12.68-.18 19.03-.18v-.1z"
              fill="#F78B86"
            />
          </svg>
        </div>
        <ConnectionsBlock className="communities">
          <h3>Communities</h3>
          <p>A place where everyone participates, shares and stays connected with others.</p>
        </ConnectionsBlock>
      </ConnectionsBlocks>
    </PaddingContainer>
  </ConnectionsSection>
);

export default Connections;
